import { ROUTE_SLUGS, SCREEN_SLUGS } from "@/shared/utils/bookingUrl";

// Discount function IDs used for both HyperKarting and BattleKart products
const DISCOUNT_IDS = {
  DISCOUNT_20_OFF: "20off-custom-discount",
  DISCOUNT_25_OFF: "25off-custom-discount",
};

// Helper to get ordinal suffix (1st, 2nd, 3rd, etc.)
const getOrdinalSuffix = (n: number): string => {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

// Helper to create discount object with dynamic message based on item position
export const createDiscountFunction = (discountPercent: 20 | 25, itemPosition: number): { id: string; message: string } => {
  const id = discountPercent === 20 ? DISCOUNT_IDS.DISCOUNT_20_OFF : DISCOUNT_IDS.DISCOUNT_25_OFF;
  const message = `${discountPercent}% Off on ${getOrdinalSuffix(itemPosition)} item`;
  return { id, message };
};

// Legacy constants for backward compatibility (deprecated - use createDiscountFunction instead)
export const DISCOUNT_FUNCTIONS = {
  LINE_ITEMS_LESS_THAN_3: { id: DISCOUNT_IDS.DISCOUNT_20_OFF, message: "20% Off on 2nd item" }, // 20% off
  LINE_ITEMS_LESS_THAN_4: { id: DISCOUNT_IDS.DISCOUNT_25_OFF, message: "25% Off on 3rd item" }, // 25% off
};

export const TRACKS = {
  MAIN_TRACK: "MAIN_TRACK",
  MINI_TRACK: "MINI_TRACK",
  JUNIOR_TRACK: "JUNIOR_TRACK",
  RACING_GAMES_TRACK: "RACING_GAMES_TRACK",
  BATTLE_KART_TRACK: "BATTLE_KART_TRACK",
  INTERMEDIATE_TRACK: "INTERMEDIATE_TRACK",
  ARCADE: "ARCADE",
};

/**
 * Booking-flow paths, built from the canonical slugs in `bookingUrl` so the
 * URL vocabulary lives in exactly one place. Keys stay named after the flow
 * step; only the emitted slugs are short.
 *
 * Superseded slugs (`main-track/seats-races` and friends) are still accepted —
 * they are rewritten to these before the router mounts.
 */
const track = (route: string) => ({
  INDEX: route,
  SEATS_RACES: `${route}/${SCREEN_SLUGS.SEATS}`,
  PLAYERS_SESSIONS: `${route}/${SCREEN_SLUGS.PLAYERS}`,
  POST_CODE: `${route}/${SCREEN_SLUGS.LOCATION}`,
  DATE_TIME: `${route}/${SCREEN_SLUGS.DATE}`,
  BOOKING_SUMMARY: `${route}/${SCREEN_SLUGS.SUMMARY}`,
  ADD_ANOTHER_ATTRACTION: `${route}/${SCREEN_SLUGS.EXTRAS}`,
  ReviewCart: `${route}/${SCREEN_SLUGS.CART}`,
});

export const ROUTES = {
  INDEX: "/",
  MAIN_TRACK: track(ROUTE_SLUGS.MAIN),
  INTERMEDIATE_TRACK: track(ROUTE_SLUGS.INTERMEDIATE),
  RACING_GAMES_TRACK: track(ROUTE_SLUGS.TRACKS),
  BATTLE_KART_TRACK: track(ROUTE_SLUGS.BATTLE_KART),
  JUNIOR_TRACK: track(ROUTE_SLUGS.JUNIOR),
  MINI_TRACK: track(ROUTE_SLUGS.MINI),
  ARCADE: {
    INDEX: ROUTE_SLUGS.ARCADE,
    ARCADE_CARD: `${ROUTE_SLUGS.ARCADE}/${SCREEN_SLUGS.CARD}`,
    ARCADE_EXPERIENCE: `${ROUTE_SLUGS.ARCADE}/${SCREEN_SLUGS.EXPERIENCE}`,
    ARCADE_CART: `${ROUTE_SLUGS.ARCADE}/${SCREEN_SLUGS.CART}`,
  },
};
